import { WebStorageStateStore } from 'oidc-client';
export const authConfig = {
    authority: process.env.REACT_APP_AUTH_AUTHORITY,
    client_id: process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_AUTH_CLIENT_ID_PROD
        : process.env.REACT_APP_AUTH_CLIENT_ID,
    redirect_uri: window.location.origin + '/signin-oidc',
    response_type: process.env.REACT_APP_AUTH_RESPONSE_TYPE,
    scope: window.location.pathname.includes('/s/qr-scanner')
        ? process.env.REACT_APP_AUTH_SCOPE_SUPPORT
        : process.env.REACT_APP_AUTH_SCOPE,
    post_logout_redirect_uri: window.location.origin,
    automaticSilentRenew: false,
    silent_redirect_uri: window.location.origin + '/silent-renew.html',
    loadUserInfo: true,
    revokeAccessTokenOnSignout: true,
    // Bảo đảm lưu vào localStorage (tránh mất user sau reload)
    userStore: new WebStorageStateStore({ store: window.localStorage })
};
